import { IonButton, IonCard, IonCardContent, IonCol, IonContent, IonHeader, IonIcon, IonImg, IonItem, IonLabel, IonPage, IonRow, IonText, IonTitle, IonToolbar, useIonAlert, useIonRouter, useIonToast, useIonViewDidEnter, useIonViewWillEnter } from '@ionic/react';
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useAppContext } from '../AppProvider';
import { logInOutline } from 'ionicons/icons';

interface RouteParams {
    token: string;
}

const Welcome: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [expired, setExpired] = useState<boolean>(true);
    const [authorizedLead, setAuthorizedLead] = useState<any>({});
    const { token } = useParams<RouteParams>();

    const { authenticateMember, settings, textLogoLoaded, fadeInTextLogo, SWTextLogo, SWOwlLogo, SWFullHorizLogo, showToast } = useAppContext(); 
    
    const router = useIonRouter();

    useIonViewWillEnter(() => {
        document.body.classList.remove('dark');
    });

    //
    // Authenticate Member
    //
    useIonViewDidEnter(() => { 
        const authenticate = async () => {
            const authenticated = await authenticateMember();   
            if(!authenticated || authenticated.mt == '') {
                setLoading(false); 
            }
            else router.push('/account/dashboard', 'forward');
        };
        authenticate();
    }); 
       
    useEffect(() => {
        if(token !== null) getLead(token);       
    }, [token]);

    const getLead = async (lt: string) => {
        const formData = new FormData();
        formData.append('lt', lt);
        try {
            const response = await fetch('https://api.besolowise.com/members/get/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            
            if(response.ok) {
                const obj = await response.json();
                //console.log(obj);
                if(obj !== null && obj.success !== false) {
                    setAuthorizedLead(obj); 
                    setExpired(false);
                    setTimeout(() => setLoading(false), 1500);
                } else {
                    setExpired(true);
                    setLoading(false);
                    showToast({
                        message: 'Data Error',
                        duration: 3000,
                        color: 'warning',
                        position: 'middle'
                    });
                }
            } else {
                setLoading(false);
                showToast({
                    message: 'Response Error.',
                    duration: 3000,
                    color: 'danger',
                    position: 'middle'
                });
            }
        } catch(error) {
            setLoading(false);
            showToast({
                message: 'Connection Error: ' + error + '. Refresh this page to try again.',
                duration: 3000,
                color: 'danger',
                position: 'middle'
            });
        }  
    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar className='ion-text-center'>
                    <IonTitle><IonImg className={textLogoLoaded ? 'fade-in' : 'fade-out'} src={SWFullHorizLogo} onIonImgDidLoad={fadeInTextLogo}></IonImg></IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding account-content-bg">
                <IonRow class='ion-justify-content-center'>
                    <IonCol size='12' sizeMd='8' sizeLg='6' sizeXl='4'>
                        <IonCard>
                            <IonCardContent>
                                <div className='ion-text-center'>
                                    {loading
                                        ? (<p>Processing...</p>)
                                        : (expired
                                            ? (<>
                                                <p>This Welcome page has expired or is otherwise invalid.</p>
                                                <hr className='ion-margin' color={'tertiary'} />
                                                <p>Please <Link to="/login">Log-in</Link> or <Link to="/register">Register</Link>.</p>
                                            </>)
                                            : (<>
                                                
                                                <h1 className='ion-text-center'><strong>Welcome, {authorizedLead.memberFirstName}!</strong></h1>
                                                <hr className='ion-margin' />
                                                <p>A verification email was just sent to</p>
                                                <p><IonText color='dark'><strong>{authorizedLead.memberEmail}</strong></IonText></p>
                                                
                                                <p>To activate your account, you must open that email and click the verification link within.</p>
                                                <p>If the verification email is not received in your Inbox, please also check your Junk / Spam folder.</p>
                                                <p>If you still cannot find the verification email, please contact our Member Support Team via the Support page on our website.</p>
                                                
                                                <p className='ion-text-center'>
                                                    <IonButton color={'secondary'} className='ion-margin' type='button' expand='block' routerLink='/login'>
                                                        Log In <IonIcon icon={logInOutline} slot='end'></IonIcon>
                                                    </IonButton>
                                                </p>
                                            </>)
                                        )
                                    }
                                </div>
                            </IonCardContent>
                        </IonCard>
                    </IonCol>
                </IonRow>    
            </IonContent>
        </IonPage>
    );
};

export default Welcome;